import React from "react";

import { getMonth, getYear } from "date-fns";
import { ChevronLeft, ChevronRight } from "icons";
import { color } from "minimum-ui/tokens";
import { ReactDatePickerCustomHeaderProps } from "react-datepicker";
import Select from "react-select";
import styled from "styled-components";

import { CommonHeaderStyles, CustomHeaderStyles } from "./Styles";

const CustomHeader =
  (months: string[]): React.FC<ReactDatePickerCustomHeaderProps> =>
  ({ date, changeYear, changeMonth, decreaseMonth, increaseMonth }) => {
    const years = Array.from({ length: 51 }, (_, i) => ({
      label: (2010 + i).toString(),
      value: 2010 + i,
    }));

    const formattedMonths = months.map((month, index) => ({
      label: month,
      value: index,
    }));

    return (
      <HeaderWrapper>
        <Navigate onClick={decreaseMonth}>
          <ChevronLeft />
        </Navigate>
        <Select
          options={formattedMonths}
          value={formattedMonths.find((item) => item.value === getMonth(date))}
          onChange={(option) => {
            if (option) {
              changeMonth(option.value);
            }
          }}
          styles={CommonHeaderStyles}
        />

        <Select
          options={years}
          value={years.find((item) => item.value === getYear(date))}
          onChange={(option) => {
            if (option) {
              changeYear(option.value);
            }
          }}
          styles={CustomHeaderStyles}
        />

        <Navigate onClick={increaseMonth}>
          <ChevronRight />
        </Navigate>
      </HeaderWrapper>
    );
  };

const HeaderWrapper = styled.header`
  display: flex;
  margin-bottom: 12px;
`;

const Navigate = styled.button.attrs({ type: "button" })`
  border: 0;
  background: none;
  cursor: pointer;
  color: ${color.blue[300]};
  &:hover {
    color: ${color.blue[500]};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export default CustomHeader;
